module.exports = __webpack_public_path__ + "img/yezi8.bdce1dbd.png";